import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  IBlockUser,
  LinkPlaidAccount,
  StripeSubscription,
  SubscriptionHistory
} from "models/UserSetting";
import {
  getBlockUsersAPI,
  getStripeSubscriptionAPI,
  getSubscriptionHistoryAPI,
  linkPlaidAccountAPI
} from "services/api/userSetting";

// Billing
export const getStripeSubscription = createAsyncThunk<StripeSubscription>(
  "loader/userSetting/billing/getStripeSubscription",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getStripeSubscriptionAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getSubscriptionHistory = createAsyncThunk<SubscriptionHistory[]>(
  "loader/userSetting/billing/getSubscriptionHistory",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getSubscriptionHistoryAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

// link plaid account
export const linkPlaidAccount = createAsyncThunk<LinkPlaidAccount, LinkPlaidAccount>(
  "loader/userSetting/profile/linkPlaidAccount",
  async (BasicDate, { rejectWithValue }) => {
    try {
      const { data } = await linkPlaidAccountAPI(BasicDate);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getBlockUsers = createAsyncThunk<IBlockUser[]>(
  "loader/userSetting/account/blockUsers",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getBlockUsersAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);
